import dayjs from 'dayjs';
import {fetchUserByID} from '../../services/real-star-api/users/user';
import { addCommasOnNumber, getDetailedDates_Ordinal } from '../../utils/utilities';

export const propertyAddressMapping = (routeProperty, routePropertyID) => {
    
    const listingTypeMap = {
        "RS": "RS Exclusive",
        "AFF": "Affiliate Exclusive",
        "": "Open Listing",
        "CB": "Co-Broke Listing"
    };

    const {
        BLOCK,
        UNIT,
        FLOOR,
        STREET_NAME,
        POSTAL_CODE,
        PROPERTY_TYPE,
        SELLING_PRICE,
        LAND_SIZE,
        TENURE,
        ROOM,
        BUILD_UP_SIZE,
        EXCLUSIVE,
        MKNO
    } = routeProperty;

    return {
        // blk , unit , floor , streetname , postal
        blk: BLOCK || "",
        unit: UNIT || "",
        floor: FLOOR || "",
        streetName: STREET_NAME || "",
        postalCode: POSTAL_CODE || "",
        propertyAddress: `${BLOCK || ""} ${UNIT || ""} ${FLOOR || ""} ${STREET_NAME || ""}`,
        propertyType: PROPERTY_TYPE || "",
        salesPrice: SELLING_PRICE ? addCommasOnNumber(parseFloat(SELLING_PRICE.toString().replace(/,/g, '')).toFixed(2)) : "",
        landArea: LAND_SIZE || "",
        tenure: TENURE || "",
        propertyID: routePropertyID || "",
        noOfBedroom: ROOM || "",
        builtInArea: BUILD_UP_SIZE || "",
        listingTypeExclusivity: listingTypeMap[EXCLUSIVE] || "",
        mukimNumber: MKNO || ""
    }
}

export const commissionPersonsMapping = (routeProperty, allAgents) => {

    const {
        CHOR,
        CHOR_COMM,
        HOR,
        HOR_COMM,
        LEADS_GIVER,
        LEADS_GIVER_COMM,
        SALESREP,
        SALESREP_COMM
    } = routeProperty;

    const CHOR_salesPerson = allAgents.find( i => i.agentID?.toString() === CHOR?.toString())
    const HOR_salesPerson = allAgents.find( i => i.agentID?.toString() === HOR?.toString())
    const LEADS_salesPerson = allAgents.find( i => i.agentID?.toString() === LEADS_GIVER?.toString())
    const SALESREP_salesPerson = allAgents.find( i => i.agentID?.toString() === SALESREP?.toString())

    return {
        salesPersonForCHOR: CHOR_salesPerson?.agentName || "",
        salesPersonForCHOR_ID: CHOR_salesPerson?.agentID || "",
        PercentForCHOR: CHOR_COMM || "",
        
        salesPersonForHOR: HOR_salesPerson?.agentName || "",
        salesPersonForHOR_ID: HOR_salesPerson?.agentID || "",
        PercentForHOR: HOR_COMM || "",

        salesPersonForLeads: LEADS_salesPerson?.agentName || "",
        salesPersonForLeads_ID: LEADS_salesPerson?.agentID || "",
        PercentForLeads: LEADS_GIVER_COMM || "",

        salesPersonForRep: SALESREP_salesPerson?.agentName || "", //sales Rep
        salesPersonForRep_ID: SALESREP_salesPerson?.agentID || "", //sales Rep
        PercentForRep: SALESREP_COMM || "",
    }
}

export const propertyAddressByPostalMapping = (propertyDetails) => {
    const { 
        ADDRESS, BLK_NO, ROAD_NAME, POSTAL
    } = propertyDetails;

    return {
        blk: BLK_NO || "",
        // unit: UNIT || "", //manual key-in
        // floor: FLOOR || "" //manual key-in,
        streetName: ROAD_NAME || "",
        postalCode: POSTAL || "",
        propertyAddress: ADDRESS || "",
    }

}

export const commissionMapping =  async (user , form , formChoice) => {
    const {
        closer_fees,
        bdc_comm_percentage,
        agency_comm_percentage
    } = user

    const managerName = closer_fees?.manager?.full_name ? `${closer_fees?.manager?.full_name} (${closer_fees?.manager?.display_name})` : ""
    const managerName_ID = closer_fees?.manager?.id || ""
    const tier1Name = closer_fees?.tier1?.full_name ? `${closer_fees?.tier1?.full_name} (${closer_fees?.tier1?.display_name})` : ""
    const tier1Name_ID = closer_fees?.tier1?.id || ""
    const tier2Name = closer_fees?.tier2?.full_name ? `${closer_fees?.tier2?.full_name} (${closer_fees?.tier2?.display_name})` : ""
    const tier2Name_ID = closer_fees?.tier2?.id || ""

    return  {
        PercentForManagerFee: closer_fees?.manager_percentage || "",
        salesPersonForManagerFee: (closer_fees?.manager_percentage || closer_fees?.manager_percentage?.toString() === "0") ? managerName  : "",
        salesPersonForManagerFee_ID: managerName_ID,

        PercentForRecruitmentT1: closer_fees?.tier1_percentage || "",
        salesPersonForRecruitmentT1: (closer_fees?.tier1_percentage || closer_fees?.tier1_percentage?.toString() === "0") ? tier1Name  : "",
        salesPersonForRecruitmentT1_ID: tier1Name_ID,

        PercentForRecruitmentT2: closer_fees?.tier2_percentage || "",
        salesPersonForRecruitmentT2: (closer_fees?.tier2_percentage || closer_fees?.tier2_percentage?.toString() === "0") ? tier2Name  : "",
        salesPersonForRecruitmentT2_ID: tier2Name_ID,

        PercentForSales: 
            form === formChoice[0] ? agency_comm_percentage.toString() || "0"  //AGENCY
            :
            form === formChoice[1] ? bdc_comm_percentage.toString() || "0" 
            : 
            "0", //BDC
        
        PercentForSPF: "0.15" 
    }
}

export const salesPersonMapping =  async (agentDetails) => {
    const {full_name , display_name , id , phone, cea_no} = agentDetails

    return  {
        salesPersonForSales: full_name ? `${full_name}` : " ",
        salesPersonForSales_ID: id ? id : " ",
        buyerAssociate1Name: full_name ? `${full_name}` : " ",
        buyerAssociate1Name_ID: id ? id : " ",
        buyerAssociate1TelNo: phone,
        buyerAssociate1CEARegNo: cea_no
    }
}

export const fieldDefaultValuesMapping = async () => {
    const defaultIdentifyingDocument = "NRIC";
    const defaultCommissionType = "%";
    const defaultGSTExclusive = "Yes";
    const defaultGSTType = "Exclusive";
    const defaultmutualAgreement = "No";
    const detailledSubmissionDate = getDetailedDates_Ordinal("dateOfSubmission" , dayjs(new Date()).format('DD-MMM-YYYY'));

    return {
        dateOfSubmission: dayjs(new Date()).format('DD-MMM-YYYY') || " ",
        dateCreated: dayjs(new Date()).format('DD-MMM-YYYY') || " ",
        ...detailledSubmissionDate,
        buyerGSTExclusive: defaultGSTExclusive,
        buyerGSTType: defaultGSTType,
        buyerMutualAgreement: defaultmutualAgreement,

        sellerGSTExclusive: defaultGSTExclusive,
        sellerGSTType: defaultGSTType,
        sellerMutualAgreement: defaultmutualAgreement,

        cobrokeGSTExclusive: defaultGSTExclusive,
        cobrokeGSTType: defaultGSTType,
        cobrokeMutualAgreement: defaultmutualAgreement,

        landlordGSTExclusive: defaultGSTExclusive,
        landlordGSTType: defaultGSTType,
        landlordMutualAgreement: defaultmutualAgreement,

        tenantGSTExclusive: defaultGSTExclusive,
        tenantGSTType: defaultGSTType,
        tenantMutualAgreement: defaultmutualAgreement,

        billToGSTExclusive: defaultGSTExclusive,
        billToGSTType: defaultGSTType,

        gSTExclusive: defaultGSTExclusive,
        gSTType: defaultGSTType,

        commissionType: defaultCommissionType,
        buyerCommissionType: defaultCommissionType,
        sellerCommissionType: defaultCommissionType,
        cobrokeCommissionType: defaultCommissionType,
        landlordCommissionType: defaultCommissionType,
        tenantCommissionType: defaultCommissionType,

        seller1IdentifyingDocuments: defaultIdentifyingDocument,
        seller2IdentifyingDocuments: defaultIdentifyingDocument,
        seller3IdentifyingDocuments: defaultIdentifyingDocument,
        seller4IdentifyingDocuments: defaultIdentifyingDocument,
        seller5IdentifyingDocuments: defaultIdentifyingDocument,
        seller6IdentifyingDocuments: defaultIdentifyingDocument,
        seller7IdentifyingDocuments: defaultIdentifyingDocument,
        seller8IdentifyingDocuments: defaultIdentifyingDocument,
        buyer1IdentifyingDocuments: defaultIdentifyingDocument,
        buyer2IdentifyingDocuments: defaultIdentifyingDocument,
        buyer3IdentifyingDocuments: defaultIdentifyingDocument,
        buyer4IdentifyingDocuments: defaultIdentifyingDocument,
        buyer5IdentifyingDocuments: defaultIdentifyingDocument,
        buyer6IdentifyingDocuments: defaultIdentifyingDocument,
        buyer7IdentifyingDocuments: defaultIdentifyingDocument,
        buyer8IdentifyingDocuments: defaultIdentifyingDocument,
        landlord1IdentifyingDocuments: defaultIdentifyingDocument,
        landlord2IdentifyingDocuments: defaultIdentifyingDocument,
        landlord3IdentifyingDocuments: defaultIdentifyingDocument,
        landlord4IdentifyingDocuments: defaultIdentifyingDocument,
        landlord5IdentifyingDocuments: defaultIdentifyingDocument,
        landlord6IdentifyingDocuments: defaultIdentifyingDocument,
        landlord7IdentifyingDocuments: defaultIdentifyingDocument,
        landlord8IdentifyingDocuments: defaultIdentifyingDocument,
        tenant1IdentifyingDocuments: defaultIdentifyingDocument,
        tenant2IdentifyingDocuments: defaultIdentifyingDocument,
        tenant3IdentifyingDocuments: defaultIdentifyingDocument,
        tenant4IdentifyingDocuments: defaultIdentifyingDocument,
        tenant5IdentifyingDocuments: defaultIdentifyingDocument,
        tenant6IdentifyingDocuments: defaultIdentifyingDocument,
        tenant7IdentifyingDocuments: defaultIdentifyingDocument,
        tenant8IdentifyingDocuments: defaultIdentifyingDocument,
    };
}